import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";

class SwtichBranchDialog extends Component {
  render() {
    const { language, confirmationMessage } = this.props;
    if (!confirmationMessage) return <></>;
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={(e) => this.props.onClose(e)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language === "english" ? "left" : "right" }}
        >
          {language === "arabic"
            ? confirmationMessage.ar_title
            : confirmationMessage.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            {language === "arabic"
              ? confirmationMessage.ar_body
              : confirmationMessage.body}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button onClick={(e) => this.props.yes(e)} color="primary">
            {language === "arabic"
              ? confirmationMessage.agree_ar_text
              : confirmationMessage.agree_text}
          </Button>
          <Button onClick={(e) => this.props.onClose(e)} color="primary">
            {language === "arabic"
              ? confirmationMessage.cancel_ar_text
              : confirmationMessage.cancel_text}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
  };
};

export default connect(mapStateToProps)(SwtichBranchDialog);
